
const paths = require.context('./', true, /\.json$/).keys();
let content = []
for (let i = paths.length - 1; i > -1; i--) {
    const file = require(`${paths[i]}`)
    content = content.concat(file)
}
export const Data = content



// WEBPACK FOOTER //
// ./src/config/zh-tw/changelog/index.js